var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReleaseEnableDetails = function SvgReleaseEnableDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "20.2 10.8 20 20"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-0.2%",
    y: "-0.1%",
    width: "100.3%",
    height: "100.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.85,
    dy: 0,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.08 0",
    type: "matrix",
    "in": "shadowOffsetOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AE875C",
    d: "M24 16l-3-3h5.4l3 3",
    style: {
      fill: "#AE875C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88653E",
    d: "M37.2 16.07l3-3.05h-7.8l-3 3",
    style: {
      fill: "#88653E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE875C",
    d: "M24 15.95h13.19v10.9H24",
    style: {
      fill: "#AE875C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C09D75",
    d: "M24 15.95h5.4v10.9h-5.4",
    style: {
      fill: "#C09D75"
    }
  }))));
};
export default SvgReleaseEnableDetails;